import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui';
import { SEO } from '../components/SEO';
import { cn } from '../lib/utils';
import { useTenant } from '../contexts/TenantContext';

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const { colorMode } = useTenant();
  const isDark = colorMode === 'dark';

  return (
    <div className={cn(
      "min-h-screen pt-28 flex items-center justify-center p-6 relative overflow-hidden",
      isDark ? "bg-black text-white" : "bg-white text-black"
    )}>
      <SEO title="404 - Page Not Found" description="The page you are looking for does not exist." noindex={true} />
      
      {/* Bauhaus Accent Blocks */}
      <div className="absolute top-[-20%] right-[-10%] w-[60%] h-[60%] bg-[#0044FF] opacity-10 blur-[100px] pointer-events-none" />
      <div className="absolute bottom-[-10%] left-[-10%] w-[50%] h-[50%] bg-[#FFD600] opacity-10 blur-[80px] pointer-events-none" />

      <div className="max-w-3xl w-full text-center relative z-10">
        <div className="inline-block relative mb-8">
          <div className="absolute inset-0 bg-[#FFD600] dark:bg-[#FFD600] z-0 skew-x-[-10deg]" />
          <h1 className="relative z-10 text-[120px] sm:text-[160px] md:text-[200px] font-black font-display leading-none tracking-tighter text-black py-4 px-8">
            404
          </h1>
        </div>
        
        <br />
        <h2 className="text-4xl sm:text-5xl font-black uppercase tracking-tighter mb-6 bg-black text-white dark:bg-white dark:text-black inline-block px-4 py-2 border-[4px] border-transparent shadow-[8px_8px_0px_#0044FF]">
          System Error: Not Found
        </h2>
        
        <p className="text-xl md:text-2xl font-bold max-w-xl mx-auto leading-snug mb-12">
          The structural node you are trying to access does not exist within the current hierarchy.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button 
            size="lg" 
            onClick={() => navigate(-1)} 
            className="bg-white dark:bg-black border-[4px] border-black dark:border-white text-black dark:text-white hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors rounded-none shadow-[4px_4px_0px_#000] dark:shadow-[4px_4px_0px_#fff] font-black w-full sm:w-auto text-lg h-auto py-4 px-8"
          >
            <ArrowLeft className="mr-2 h-5 w-5" /> GO BACK
          </Button>
          <Button 
            size="lg" 
            onClick={() => navigate('/')} 
            className="bg-black text-white dark:bg-white dark:text-black font-bold uppercase tracking-wider py-4 px-8 rounded-none border-[4px] border-transparent hover:border-black dark:hover:border-white hover:bg-brand-primary transition-colors text-lg shadow-[8px_8px_0px_#000000] dark:shadow-[8px_8px_0px_#ffffff] w-full sm:w-auto h-auto"
          >
            <Home className="mr-2 h-5 w-5" /> RETURN HOME
          </Button>
        </div>
      </div>
    </div>
  );
};
